<template>
<div class="z-body">
 	<header class="z-header">
		<div><router-link to="/user/login"><img src="../../assets/sysbars/left.png" /></router-link></div>
		<div>{{$t('邮箱登录')}}</div>
		<div></div>
	</header>
	<section>
	  <div class="inputBox">
		<div style="width: 10%;">
		  <img class="z-icon" src="../../assets/icon/register/email.png">
		</div>
		<div style="width: 60%;">
		  <input v-model="email" style="outline:none;font-size: 16px" :placeholder="$t('邮箱')">
		</div>
		<div style="width: 30%;text-align: right">
		  <div class="z-icon" ></div>
		</div>
	  </div>
	</section>
	<section>
	  <div style="padding-right: 0px" class="inputBox" >
		<div style="width: 10%;">
		  <img class="z-icon" src="../../assets/icon/register/smscode.png">
		</div>
		<div style="border-right: 1px solid black;width: 60%;height: 100%;line-height: 60px">
		  <input v-model="code" style="outline:none;font-size: 16px" :placeholder="$t('验证码')">
		</div>
		<div v-if="!sendOnOff" @click="getCode" style="height: 100%;line-height: 60px;width: 30%;text-align: center;font-size: 15px">
		  {{$t('获取验证码')}}
		</div>
		<div v-if="sendOnOff" style="height: 100%;line-height: 60px;width: 30%;text-align: center;font-size: 15px">
		  {{coutDown}}
		</div>
	  </div>
	</section>
	<section style="text-align: center;padding:20px 0px;">
	  <div @click="login" class="common-btn">{{$t('登录')}}</div>
	</section>
  </div>
</template>

<script>
	export default {
		name: 'emailLogin',
		data() {
			return {
			  loginName:"",
			  email:"",
			  code:"",
			  sendOnOff:false,
			  coutDown:60
			}
		},
		mounted() {

		},
		methods: {
		  getCode:function () {
			let _this=this;
			if(this.email==""){
			  this.$store.commit('layer',this.$t('请输入')+this.$t('手机号'))
			}else{
			  this.post('api/index/sendEmailCode', {
				email: this.email,
				cateid:3
			  }).then((res) => {

				if(res.code==0){
				  _this.sendOnOff=true
				  let itmer=setInterval(function () {
					if(_this.coutDown==0){
					  clearInterval( itmer )
					  _this.coutDown=60
					  _this.sendOnOff=false
					}else {
					  _this.coutDown=_this.coutDown-1
					}
				  },1000)
				}
				this.$store.commit('layer',res.msg)
			  })
			}
		  },
		  login:function () {
			let _this=this
			if(this.email=="" || this.code==""){
			  this.$store.commit('layer',this.$t('部分信息未填写'))
			}else{
			  this.post('api/index/emailLogin', {
				name: this.loginName,
				email: this.email,
				code:this.code
			  }).then((res) => {
				this.$store.commit('layer',this.$t(res.msg))
				if(res.code==0){
					_this.setToken(res.data.token)
					_this.setUid(res.data.uid)
					_this.jump('/index')
				}
			  })
			}
		  }
		}
	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .inputBox{
	/* background-color: #424355; */
  background-color: #fff;
	display: flex;
	justify-content: space-between;
	align-items: center;
	height: 60px;
	padding:0 30px 0 30px;
	margin-bottom:2px;
	border-bottom: 1px solid #28293D;
  }
</style>



// WEBPACK FOOTER //
// src/pages/user/emailLogin.vue